/**
 * Site-scoped login redirect: allow only server-suggested URLs for known CLC hosts.
 * Prevents open redirect; suggestedLoginUrl is only ever used when backend returns it.
 */
const ALLOWED_REDIRECT_HOSTS = new Set([
  'owners.dev.clcvacation.com',
  'owners.clcvacation.com',
  'admin.dev.clcconciergeservices.com',
  'admin.dev.clcvacation.com',
  'dev.clcconciergeservices.com',
  'clcconciergeservices.com',
]);

/**
 * @param {string} url
 * @returns {boolean}
 */
export function isAllowedRedirectUrl(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') return false;
    return ALLOWED_REDIRECT_HOSTS.has(u.hostname.toLowerCase());
  } catch {
    return false;
  }
}
